// Check if a string can be split into an array
const canSplit = function (str: any, token: any) {
  return (str || "").split(token).length > 1;
};

export const isNumber = (str: any) => {
  if (str.trim() === "") {
    return false;
  }
  return !isNaN(str);
};
